<template>
<v-container max-width="100%" style="margin-top: 5%;" fluid>
    <CRUDFuncionarios />
</v-container>
</template>

<script>
// @ is an alias to /src
import CRUDFuncionarios from '@/components/CRUDFuncionarios.vue'

export default {
  name: 'Funcionarios',
  components: {
    CRUDFuncionarios
  }
}
</script>